import forOwn from 'mout/object/forOwn'

export default function convertAnswersByItem(answersByItem) {
  let converted = {}
  forOwn(answersByItem, (val, key) => {
    converted[key] = {
      [val]: 1
    }
  })
  return converted
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/convertAnswersByItem.js